export default "__VITE_ASSET__BNbmNwfJ__"